function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 32.13,
  cy: 32.02,
  r: 30.23,
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2.89
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.14 62.31c7.7 0 13.94-13.56 13.94-30.29S39.84 1.74 32.14 1.75 18.2 15.31 18.2 32s6.24 30.31 13.94 30.31zM32.11 1.74v60.51M60.04 41.31H4.18M60.04 20.36H4.18",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2.89
});

function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+Z2xvYmU8L3RpdGxlPjxjaXJjbGUgY3g9IjMyLjEzIiBjeT0iMzIuMDIiIHI9IjMwLjIzIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjIuODkiLz48cGF0aCBkPSJNMzIuMTQsNjIuMzFjNy43LDAsMTMuOTQtMTMuNTYsMTMuOTQtMzAuMjlTMzkuODQsMS43NCwzMi4xNCwxLjc1LDE4LjIsMTUuMzEsMTguMiwzMiwyNC40NCw2Mi4zMSwzMi4xNCw2Mi4zMVoiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMi44OSIvPjxsaW5lIHgxPSIzMi4xMSIgeTE9IjEuNzQiIHgyPSIzMi4xMSIgeTI9IjYyLjI1IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjIuODkiLz48bGluZSB4MT0iNjAuMDQiIHkxPSI0MS4zMSIgeDI9IjQuMTgiIHkyPSI0MS4zMSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyLjg5Ii8+PGxpbmUgeDE9IjYwLjA0IiB5MT0iMjAuMzYiIHgyPSI0LjE4IiB5Mj0iMjAuMzYiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMi44OSIvPjwvc3ZnPg==";
export { SvgGlobe as ReactComponent };